import { render, staticRenderFns } from "./EbPassword.vue?vue&type=template&id=dfdec824&scoped=true"
import script from "./EbPassword.vue?vue&type=script&lang=js"
export * from "./EbPassword.vue?vue&type=script&lang=js"
import style0 from "./EbPassword.vue?vue&type=style&index=0&id=dfdec824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdec824",
  null
  
)

export default component.exports